import Products from './Products'

export default Products



// WEBPACK FOOTER //
// ./src/components/Products/index.js